/*
 * @Description:
 * @Version: 2.0
 * @Autor: 胡彩丽 hucaili@qfei.cn
 * @LastEditors: 胡彩丽 hucaili@qfei.cn
 */
import { use } from 'echarts/core';
import { CanvasRenderer } from 'echarts/renderers';
import { BarChart, LineChart, PieChart, RadarChart, MapChart } from 'echarts/charts';
import { TitleComponent, GridComponent, TooltipComponent, LegendComponent, DataZoomComponent, GraphicComponent, VisualMapComponent } from 'echarts/components';

// echarts
use([
  CanvasRenderer,
  // 导入 柱状图 线图 饼图 雷达图 如果需要其他的 再导入即可,https://echarts.apache.org/examples/zh/index.html#chart-type-line demo网站可以查看需要导入的图例的组件名
  BarChart,
  LineChart,
  PieChart,
  RadarChart,
  MapChart,
  // 配置需要的组件
  TitleComponent,
  GridComponent,
  TooltipComponent,
  LegendComponent,
  DataZoomComponent,
  GraphicComponent,
  VisualMapComponent
]);
// 需要导出的公共组件
import IconPlatformBaidu from './icons/IconPlatformBaidu.vue';
import IconClue from './icons/IconClue.vue';
import IconFeiShuMinutes from './icons/IconFeiShuMinutes.vue';
import IconSetting from './icons/IconSetting.vue';
import IconClient from './icons/IconClient.vue';
import IconDialPhone from './icons/IconDialPhone.vue';
import IconWarn from './icons/IconJingGao.vue';
import IconFieldOrder from './icons/IconFieldOrder.vue';

import IconOpportunity from './icons/IconOpportunity.vue';
import IconProductMenu from './icons/IconProductMenu.vue';
import IconBusiness from './icons/IconBusiness.vue';
import IconTransferClient from './icons/IconTransferClient.vue';
import IconTransferOpportunity from './icons/IconTransferOpportunity.vue';
import IconCooperation from './icons/IconCooperation.vue';
import IconChat from './icons/IconChat.vue';
import IconCount from './icons/IconCount.vue';
import IconQuote from './icons/IconQuote.vue';
import IconMoney from './icons/IconMoney.vue';
import IconExcel from './icons/upload/IconExcel.vue';
import IconWord from './icons/upload/IconWord.vue';
import IconPdf from './icons/upload/IconPdf.vue';
import IconPpt from './icons/upload/IconPpt.vue';
import IconZip from './icons/upload/IconZip.vue';
import IconFile from './icons/upload/IconFile.vue';
import IconOther from './icons/upload/IconOther.vue';
import IconImg from './icons/upload/IconImg.vue';
import IconVideo from './icons/upload/IconVideo.vue';
import IconCode from './icons/IconCode.vue';
import IconSubForm from './icons/IconSubForm.vue';
import IconRequired from './icons/iconRequired.vue';
import IconLog from './icons/IconLog.vue';
import IconDing from './icons/IconDing.vue';
import IconLeadsPool from './icons/IconLeadsPool.vue';
import IconSortDown from './icons/IconSortDown.vue';
import IconSortUp from './icons/IconSortUp.vue';

import IconLayoutAdd from './icons/IconLayoutAdd.vue';
import IconLayoutDetail from './icons/IconLayoutDetail.vue';
import IconLayoutEdit from './icons/IconLayoutEdit.vue';
import IconLayoutList from './icons/IconLayoutList.vue';
import IconLayoutDel from './icons/IconLayoutDel.vue';
import IconChaolianjie from './icons/IconChaolianjie.vue'; //超链接
import IconChazhaoguanlian from './icons/IconChazhaoguanlian.vue'; //查找关联
import IconDanhang from './icons/IconDanhang.vue'; //单行文本
import IconDanxuan from './icons/IconDanxuan.vue'; //单选
import IconDuohangwenben from './icons/IconDuohangwenben.vue'; //多行文本
import IconDuoxuan from './icons/IconDuoxuan.vue'; //多选
import IconFujian from './icons/IconFujian.vue'; //附件
import IconJilianxuanze from './icons/IconJilianxuanze.vue'; //级联选择
import IconRenyuan from './icons/IconRenyuan.vue'; //人员
import IconRiqi from './icons/IconRiqi.vue'; //日期
import IconShuzi from './icons/IconShuzi.vue'; //数字
import IconTixing from './icons/IconTixing.vue'; //提醒
import IconXialadanxuan from './icons/IconXialadanxuan.vue'; //下拉单选
import IconXialaduoxuan from './icons/IconXialaduoxuan.vue'; //下拉多选
import IconZujian from './icons/IconZujian.vue'; //组件
import IconAutoFlow from './icons/IconAutoFlow.vue'; //自动化流程
import IconSendMsg from './icons/IconSendMsg.vue'; //发送飞书消息
import IconBaifenbi from './icons/IconBaifenbi.vue'; //23--百分比
import IconBianma from './icons/IconBianma.vue'; //组件
import IconTable from './icons/IconTable.vue'; //表格图表
import IconMenuInterface from './icons/IconMenuInterface.vue'; //菜单界面
import IconSwitchIdentity from './icons/IconSwitchIdentity.vue'; //登录账户切换身份
import IconFuwenben from './icons/IconFuwenben.vue'; //富文本
import IconTabOne from './icons/IconTabOne.vue'; //流程阶段页签1
import IconTabTwo from './icons/IconTabTwo.vue'; //流程阶段页签2
import IconMetCondition from './icons/IconMetCondition.vue'; //满足条件
import IconTimeTrigger from './icons/IconTimeTrigger.vue'; //定时触发
import IconAddRecord from './icons/IconAddRecord.vue'; //新增记录
import IconListGroup from './icons/IconListGroup.vue';
import IconColumnSetting from './icons/IconColumnSetting.vue';
import IconTableFiltrate from './icons/IconTableFiltrate.vue';
import IconTableSort from './icons/IconTableSort.vue';
import IconTaskCenter from './icons/IconTaskCenter.vue';

import IconCaoZuoLaiYuan from './icons/IconCaoZuoLaiYuan.vue';
import IconCaoZuoLeiXing from './icons/IconCaoZuoLeiXing.vue';
import IconCaoZuoZiDuan from './icons/IconCaoZuoZiDuan.vue';

import IconDepart from './icons/IconDepart.vue';
import IconPercent from './icons/IconPercent.vue';
import IconComment from './icons/IconComment.vue';
import IconCommentActive from './icons/IconCommentActive.vue';
import IconUpvote from './icons/IconUpvote.vue';
import IconUpvoteActive from './icons/IconUpvoteActive.vue';
import IconGroup from './icons/IconGroup.vue';
import IconService from './icons/IconService.vue'; //售后服务
import IconPriceSheet from './icons/IconPriceSheet.vue';
import IconContract from './icons/IconContract.vue'; //销售合同
import IconOrder from './icons/IconOrder.vue'; //订单 IconOrder
import IconResult from './icons/IconResult.vue'; //数据结果
import IconDoing from './icons/IconDoing.vue'; //过程结果
import IconVolcanoVoice from './icons/IconVolcanoVoice.vue'; //火山语音
import IconApprove from './icons/IconApprove.vue'; //审批列表
import IconTenement from './icons/IconTenement.vue'; //租户头像
import IconMultiMobile from './icons/IconMultiMobile.vue'; //多手机号
import XlChart from './xl-chart/xl-chart.vue';
import XlTable from './xl-table/xl-table.vue';
import XlDatePicker from './xl-date-picker/xl-date-picker.vue';
import XlSearch from './xl-search/xl-search.vue';
import XlMember from './xl-search/xl-member/xl-member.vue';
import FhLoading from './fh-loading/fh-loading.vue';
import XlPrice from './xl-price/xl-price.vue';
import FhPerson from './fh-person/fh-person.vue';

import XlTreeMemberModal from './xl-tree-member-select/index.vue';
import xlUserDepart from './xl-user-depart/xl-user-depart.vue';
import XlColSelect from './xl-col-select/xl-col-select.vue';
import XlAvatar from './xl-avatar/xl-avatar.vue';
import XlEmpty from './xl-empty/xl-empty.vue';
import xlStatus from './xl-status/xl-status.vue'; //所有对象的生命状态
import XlTab from './xl-tab/xl-tab.vue';
import XlTree from './xl-tree/xl-tree.vue';
import XlReturn from './public/xl-return/xl-return.vue';
import XlBreadcrumb from './xl-breadcrumb/xl-breadcrumb.vue';
import XlNoPermission from './xl-no-permission/xl-no-permission.vue';
import XlOutCallMky from './out-call-mky/out-call-mky.vue';
import XlOutCallTky from './out-call-kty/out-call-kty.vue';
import XlOutCallCxkj from './out-call-cxkj/out-call-cxkj.vue';
import XlSelectTree from './xl-select-tree/xl-select-tree.vue'; //自定义级联选择器
import XlGlobalTree from './xl-global-tree/xl-global-tree.vue'; //自定义级联选择器
import XlDot from './xl-dot/xl-dot.vue';
import XlOrder from './public/xl-order/xl-order.vue'; //销售订单
import FhAttachmentUpload from './upload/fh-attachment-upload/fh-attachment-upload.vue'; //上传
import FhAttachmentPreview from './upload/fh-attachment-preview/fh-attachment-preview.vue'; //上传预览
import FhImgWatermark from './upload/fh-attachment-watermark/fh-attachment-watermark.vue'; //拍照配置组件
import FhUploadModal from './upload/fh-upload-modal/fh-upload-modal.vue'; //附件上传弹窗
import FhPreviewModal from './upload/fh-preview-modal/index.vue'; //预览弹窗

import XlUpload from './public/xl-upload/xl-upload.vue'; //上传

import XlFlowStage from './public/xl-flow-stage/xl-flow-stage.vue'; //流程阶段
import XlLabelText from './public/xl-label-text/xl-label-text.vue'; //对表单label显示处理
import XlFindObj from './xl-find-obj/xl-find-obj.vue'; // 查找对象，对象关联
import XlFollowField from './xl-follow-field/xl-follow-field.vue'; // 动态对象字段
import XlOperationLog from './public/xl-operation-log/xl-operation-log.vue'; // 操作日志
import XlAssociation from '@/components/xl-association/xl-association.vue';
import XlEntityDataList from '@/components/public/xl-entity-data-list/xl-entity-data-list.vue';
import XlHeader from './fh-detail/components/header/index.vue'; //头部
import XlSchedule from './public/xl-schedule/xl-schedule.vue'; //日程
import XlUpdateSchedule from './public/xl-schedule/xl-update-schedule/xl-update-schedule.vue'; //更新日程
import XlContacts from './public/xl-contacts/xl-contacts.vue'; //联系人
import XlCalllog from './public/xl-calllog/xl-calllog.vue'; //通话记录
import XlClueTransform from './public/xl-clue-transform/xl-clue-transform.vue'; //线索转化记录
import XlCooperation from './public/xl-cooperation/xl-cooperation.vue'; //协作人
import QfConditionUltra from './qf-condition-ultra/qf-condition-ultra.vue'; // 条件筛选

import XlRecord from './public/xl-record/xl-record.vue'; //动态记录--列表
import XlSelectContacts from './public/xl-select-contacts/xl-select-contacts.vue'; //拨打-选择联系人
import XlUpdateRecords from './public/xl-update-records/xl-update-records.vue'; // 更新动态记录--编辑/新增
import XlTransfer from './public/xl-transfer/xl-transfer.vue'; //转移批量转移
import XlBusinessInformation from './public/xl-business-information/xl-business-information.vue'; //关联工商信息
import XlBusinessMessage from './public/xl-business-message/xl-business-message.vue'; //展示工商信息
import XlCloudDocument from './public/xl-cloud-document/xl-cloud-document.vue'; //云文档/附件
import XlExport from './public/xl-export/xl-export.vue'; //导入
import XlImportEdit from './public/xl-import-edit/xl-import-edit.vue'; //导入并修改
import XlContract from './public/xl-contract/xl-contract.vue'; //销售合同
import XlPriceSheet from './public/xl-price-sheet/xl-price-sheet.vue'; //报价单
import XlBandCustomer from './public/xl-band-customer/xl-band-customer.vue'; //商机及合同绑定客户
import XlRepeatButton from './public/xl-repeat-button/xl-repeat-button.vue'; //查重按钮弹框
import BingDataSync from './customization/bing-data-sync/bing-data-sync.vue'; //同步数据
import XlFieldCascade from './public/xl-field-cascade/xl-field-cascade.vue'; //计算字段-选择字段
import XlGuide from './xl-guide/xl-guide.vue'; //新手引导
import BulkEditing from './customization/bulk-editing/bulk-editing.vue'; //导入

import XlUpdateFields from './layout/ly-update-fields/ly-update-fields.vue'; //新增编辑所有字段类型
import FhUpdateFields from './fh-add-edit/components/fh-update-fields/fh-update-fields.vue'; //新增编辑所有字段类型新
import FhHeader from './fh-detail/components/header/index.vue'; //布局详情头部插槽
import FhAbstract from './fh-set-fields/components/abstract/index.vue'; //布局详情摘要区
import LyAddEdit from './layout/ly-add-edit/ly-add-edit.vue'; //编辑添加对象
import FhAddEdit from './fh-add-edit/fh-add-edit.vue'; //编辑添加对象新版
import FhTabPage from './fh-detail/components/tab-page/index.vue'; //布局详情页签区
import FhFields from './fh-detail/components/fields-show/index.vue'; //抽取的所有字段表格组件
// import LyTable from './layout/ly-table/ly-table.vue'; //抽取的所有字段表格组件
import LyAttachmentList from './layout/ly-attachment-list/ly-attachment-list.vue'; //附件类型的展示
import LyAssociation from './layout/ly-association/ly-association.vue'; //查找关联跳转
import lyForm from './layout/ly-form/ly-form.vue'; //对象新增、编辑form组件
import lyFormTable from './layout/ly-form-table/ly-form-table.vue'; //对象新增、编辑关联表格组件
import lySubformTable from './layout/ly-sub-form/ly-sub-form.vue'; //子表单
import LyList from './layout/ly-list/ly-list.vue'; //主对象、自定义对象列表抽离

import LyShowFilters from './layout/ly-show-filters/ly-show-filters.vue'; //展示筛选条件
import FhTable from './fh-table/fh-table.vue'; //TDesign表格
import lyListGroupLayout from './layout/ly-list-group-layout/ly-list-group-layout.vue'; // 列表的布局（被引入ly-list组件使用）
import LyListLayout from './layout/ly-list-layout/ly-list-layout.vue'; // 列表的布局（被引入ly-list组件使用）

import lyListShortcutButtons from './layout/ly-list-shortcut-buttons/ly-list-shortcut-buttons.vue'; //列表--快捷操作公共组件
import lyListBatchButtons from './layout/ly-list-batch-buttons/ly-list-batch-buttons.vue'; //列表-批量公共组件

import lyComputedTip from './layout/ly-computed-tip/ly-computed-tip.vue'; // 计算字段头部提示
import lyComputedIconTips from './layout/computed-tips/computed-tips.vue';
import lySkeletonRecord from './layout/ly-skeleton-record/ly-skeleton-record.vue'; // 跟进记录骨架屏
import lySkeletonOperation from './layout/ly-skeleton-operation/ly-skeleton-operation.vue';
import FhColSelect from './fh-col-select/fh-col-select.vue'; //新列表列选择组件
import TableInnerEdit from './layout/table-inner-edit/table-inner-edit.vue'; //表格内编辑组件(旧）
import TableInnerEditContent from './layout/table-inner-edit/table-inner-edit-content/table-inner-edit-content.vue'; //表格内编辑组件内容（旧）

import lyQuickEdit from './layout/ly-quick-Edit/ly-quick-Edit.vue'; //表格内编辑组件（新）

import LySkeleton from './layout/ly-skeleton/ly-skeleton.vue'; //骨架屏组件
import lyRichText from './layout/ly-rich-text/ly-rich-text.vue'; // 列表页富文本内容展示组件
import lyEditorDialog from './layout/ly-editor-dialog/ly-editor-dialog.vue'; // 列表页富文本内容展示组件
import LyAdvancedFilter from './layout/ly-advanced-filter/ly-advanced-filter.vue'; //高级筛选组件
import DropdownFilter from './layout/ly-advanced-filter/components/dropdown-filter/dropdown-filter.vue'; //下拉筛选组件
import FieldFilter from './layout/ly-advanced-filter/components/field-filter/field-filter.vue'; //字段筛选组件
import CommonSearch from './layout/ly-advanced-filter/components/common-search/common-search.vue'; //保存常用检索弹窗
import LyRecipient from './layout/ly-recipient/ly-recipient.vue'; //接收人组件
import XlMemberTips from './public/xl-member-tips/xl-member-tips.vue'; //成员提示组件
import LyFieldMapping from './layout/ly-field-mapping/ly-field-mapping.vue'; //字段映射配置
import LyFieldFilter from './layout/ly-field-filter/ly-field-filter.vue';

import FhSelect from './fh-select/fh-select.vue'; // 烽火select组件

import LyDetail from './fh-detail/index.vue'; //系统对象详情页抽离公共组件
import FhButtons from './fh-detail/components/buttons/index.vue'; //系统对象中详情的按钮集合
import QfDotAnimation from './qf-dot-animation/qf-dot-animation.vue'; //点动画
import LyAvatar from './layout/ly-avatar/ly-avatar.vue'; //人员头像
import XlDistribution from './public/xl-distribution/xl-distribution.vue'; // 分配线索池
import XlPoolTransfer from './public/xl-pool-transfer/xl-pool-transfer.vue'; // 转移线索池
import XlParamCondition from './xl-param-condition/xl-param-condition.vue'; //带筛选的字段范围
import XlSourceCondition from './xl-source-condition/xl-source-condition.vue'; //带筛选的字段范围
import XlColorPicker from './xl-color-picker/xl-color-picker.vue'; // 颜色选择器
import FindFieldCondition from './find-field-condition/find-field-condition.vue'; //带筛选的条件组件（流程引擎和线索池使用）
import LyColMore from './layout/ly-col-more/ly-col-more.vue'; //表格头部的列更多
// import XlTreeOrganization from './xl-tree-organization/xl-tree-organization.vue';
// import XlTreeOrg from './xl-tree-organization/index.vue'; //组织架构树
// import XlTreeOrg from './xl-tree-member-select/xl-tree-org.vue'; //组织架构树
import SysObj from '../views/sys-obj/sys-obj.vue';
import XlTreeOrg from './xl-tree-member-select/xl-tree-org.vue'; //组织架构树
import XlEditDiv from './xl-edit-div/xl-edit-div.vue'; // 可编辑div

import ChangePassword from './change-password/change-password.vue';
import XlCheckName from './public/xl-check-name/xl-check-name.vue'; // 校验线索 客户 商机唯一性
import XlDateVariable from './public/xl-date-variable/xl-date-variable.vue'; //日期变量组件
import WEditor from './w-editor/w-editor.vue';
import OrgPersionList from './org-persion-list/org-persion-list.vue';
import XlTabs from './xl-tabs/xl-tabs.vue'; // tab页封装
/************************
 * 选择图标组件使用图标start
 ************************/
import Baojiadan from './select-icons/Baojiadan.vue';
import BianjixiansuoiDibu from './select-icons/BianjixiansuoiDibu.vue';
import Bianjiye from './select-icons/Bianjiye.vue';
import BookOpen from './select-icons/BookOpen.vue';
import Bumen from './select-icons/Bumen.vue';
import Chanpin from './select-icons/Chanpin.vue';
import Chaolianjie from './select-icons/Chaolianjie.vue';
import Clue from './select-icons/Clue.vue';
import Dailishang from './select-icons/Dailishang.vue';
import Dancidaoru from './select-icons/Dancidaoru.vue';
import Danhangwenben from './select-icons/Danhangwenben.vue';
import Danxuan from './select-icons/Danxuan.vue';
import Daorujilu from './select-icons/Daorujilu.vue';
import Dianzan from './select-icons/Dianzan.vue';
import DibubiaoqianlaniconGongzuorichengMoren from './select-icons/DibubiaoqianlaniconGongzuorichengMoren.vue';
import DibubiaoqianlaniconKehuMoren from './select-icons/DibubiaoqianlaniconKehuMoren.vue';
import DibubiaoqianlaniconLianxirenMoren from './select-icons/DibubiaoqianlaniconLianxirenMoren.vue';
import DibubiaoqianlaniconShangjiMoren from './select-icons/DibubiaoqianlaniconShangjiMoren.vue';
import DibubiaoqianlaniconShouyeMoren from './select-icons/DibubiaoqianlaniconShouyeMoren.vue';
import Dingdan from './select-icons/Dingdan.vue';
import Dingdan0 from './select-icons/Dingdan0.vue';
import Dingshirenwu from './select-icons/Dingshirenwu.vue';
import Duohangwenben from './select-icons/Duohangwenben.vue';
import Duoxuan from './select-icons/Duoxuan.vue';
import Fujian from './select-icons/Fujian.vue';
import GengduoDibu from './select-icons/GengduoDibu.vue';
import Headset from './select-icons/Headset.vue';
import Hetong from './select-icons/Hetong.vue';
import HuoshanyuyinfeiyongB27632pf from './select-icons/HuoshanyuyinfeiyongB27632pf.vue';
import Jiebang from './select-icons/Jiebang.vue';
import Jilianxuanze from './select-icons/Jilianxuanze.vue';
import Jine from './select-icons/Jine.vue';
import Jisuanleixing from './select-icons/Jisuanleixing.vue';
import Kehu from './select-icons/Kehu.vue';
import Liebiaoye from './select-icons/Liebiaoye.vue';
import LiuchengguanliB9jnokl3 from './select-icons/LiuchengguanliB9jnokl3.vue';
import Maikefeng from './select-icons/Maikefeng.vue';
import PeopleSafe from './select-icons/PeopleSafe.vue';
import Pinglun from './select-icons/Pinglun.vue';
import Renwu from './select-icons/Renwu.vue';
import Renyuan from './select-icons/Renyuan.vue';
import Riqi from './select-icons/Riqi.vue';
import Setting from './select-icons/Setting.vue';
import Shaixuan from './select-icons/Shaixuan.vue';
import Shanchu from './select-icons/Shanchu.vue';
import Shangji from './select-icons/Shangji.vue';
import Shenpi from './select-icons/Shenpi.vue';
import Shouhoufuwu from './select-icons/Shouhoufuwu.vue';
import Shuzi from './select-icons/Shuzi.vue';
import Sousuo from './select-icons/Sousuo.vue';
import Tianjiaqun from './select-icons/Tianjiaqun.vue';
import TianjiaqunQunliao from './select-icons/TianjiaqunQunliao.vue';
import Tianjiaxiezuoren from './select-icons/Tianjiaxiezuoren.vue';
import Tixiaogongju from './select-icons/Tixiaogongju.vue';
import Tixing from './select-icons/Tixing.vue';
import VideoOne from './select-icons/VideoOne.vue';
import VideoTwo from './select-icons/VideoTwo.vue';
import Weikaishi from './select-icons/Weikaishi.vue';
import Xialadanxuan from './select-icons/Xialadanxuan.vue';
import Xialaduoxuan from './select-icons/Xialaduoxuan.vue';
import Xiangqingye from './select-icons/Xiangqingye.vue';
import XinjianrichengDibu from './select-icons/XinjianrichengDibu.vue';
import Xinjianye from './select-icons/Xinjianye.vue';
import Yinyongziduan from './select-icons/Yinyongziduan.vue';
import Zan from './select-icons/Zan.vue';
import Zhanghao from './select-icons/Zhanghao.vue';
import ZhanghaoquanxianBikgkki7 from './select-icons/ZhanghaoquanxianBikgkki7.vue';
import Zhaozhaoguanlian from './select-icons/Zhaozhaoguanlian.vue';
import ZhuanhuaDibu from './select-icons/ZhuanhuaDibu.vue';
import Zidonghuaguanli from './select-icons/Zidonghuaguanli.vue';
import Zujian1 from './select-icons/Zujian1.vue';
import Zuopin from './select-icons/Zuopin.vue';
import Zuzhiquanxian from './select-icons/Zuzhiquanxian.vue';
import XlSelectIcon from './xl-select-icon/xl-select-icon.vue';
import LyTransfer from './layout/ly-transfer/ly-transfer.vue';
import FhAdvertisingAccount from './select-icons/FhAdvertisingAccount.vue';
import FhAfterSalesProducts from './select-icons/FhAfterSalesProducts.vue';
import FhAfterSalesService from './select-icons/FhAfterSalesService.vue';
import FhAgent from './select-icons/FhAgent.vue';
import FhBank from './select-icons/FhBank.vue';
import FhBusinessCustomers from './select-icons/FhBusinessCustomers.vue';
import FhContract from './select-icons/FhContract.vue';
import FhContractRenewal from './select-icons/FhContractRenewal.vue';
import FhCustomerPool from './select-icons/FhCustomerPool.vue';
import FhDailySchedule from './select-icons/FhDailySchedule.vue';
import FhDataAnalysis from './select-icons/FhDataAnalysis.vue';
import FhDataReport from './select-icons/FhDataReport.vue';
import FhFinance from './select-icons/FhFinance.vue';
import FhFund from './select-icons/FhFund.vue';
import FhInvoice from './select-icons/FhInvoice.vue';
import FhLawyer from './select-icons/FhLawyer.vue';
import FhLead from './select-icons/FhLead.vue';
import FhLeadPool from './select-icons/FhLeadPool.vue';
import FhMarketingCampaign from './select-icons/FhMarketingCampaign.vue';
import FhMerchandise from './select-icons/FhMerchandise.vue';
import FhOrder from './select-icons/FhOrder.vue';
import FhOverseasCustomers from './select-icons/FhOverseasCustomers.vue';
import FhPartner from './select-icons/FhPartner.vue';
import FhProcurementList from './select-icons/FhProcurementList.vue';
import FhProductManagement from './select-icons/FhProductManagement.vue';
import FhProjectManagement from './select-icons/FhProjectManagement.vue';
import FhQuotation from './select-icons/FhQuotation.vue';
import FhRetailCustomers from './select-icons/FhRetailCustomers.vue';
import FhReturnOrder from './select-icons/FhReturnOrder.vue';
import FhSettingsCenter from './select-icons/FhSettingsCenter.vue';
import FhSubscribed from './select-icons/FhSubscribed.vue';
import FhTransactionRecord from './select-icons/FhTransactionRecord.vue';
import FhWonDeal from './select-icons/FhWonDeal.vue';
import FhWorkbench from './select-icons/FhWorkbench.vue';
import QfTable from './table/qf-table/qf-table.vue';
/************************
 * 选择图标组件使用图标end
 ************************/
import LyTagFields from './layout/ly-tag-fields/ly-tag-fields.vue';
import XlTablePopover from './public/xl-table-popover/xl-table-popover.vue';
/***********************************/
import customFieldCondition from './custom-field-condition/custom-field-condition.vue'; // 颜色选择器
import CustomSearchUltra from './custom-search-ultra/custom-search-ultra.vue'; // 高级筛选组件

export default {
  install(Vue) {
    Vue.component('FhAdvertisingAccount', FhAdvertisingAccount);
    Vue.component('FhAfterSalesProducts', FhAfterSalesProducts);
    Vue.component('FhAfterSalesService', FhAfterSalesService);
    Vue.component('FhAgent', FhAgent);
    Vue.component('FhBank', FhBank);
    Vue.component('FhBusinessCustomers', FhBusinessCustomers);
    Vue.component('FhContract', FhContract);
    Vue.component('FhContractRenewal', FhContractRenewal);
    Vue.component('FhCustomerPool', FhCustomerPool);
    Vue.component('FhDailySchedule', FhDailySchedule);
    Vue.component('FhDataAnalysis', FhDataAnalysis);
    Vue.component('FhDataReport', FhDataReport);
    Vue.component('FhFinance', FhFinance);
    Vue.component('FhFund', FhFund);
    Vue.component('FhInvoice', FhInvoice);
    Vue.component('FhLawyer', FhLawyer);
    Vue.component('FhLead', FhLead);
    Vue.component('FhLeadPool', FhLeadPool);
    Vue.component('FhMarketingCampaign', FhMarketingCampaign);
    Vue.component('FhMerchandise', FhMerchandise);
    Vue.component('FhOrder', FhOrder);
    Vue.component('FhOverseasCustomers', FhOverseasCustomers);
    Vue.component('FhPartner', FhPartner);
    Vue.component('FhProcurementList', FhProcurementList);
    Vue.component('FhProductManagement', FhProductManagement);
    Vue.component('FhProjectManagement', FhProjectManagement);
    Vue.component('FhQuotation', FhQuotation);
    Vue.component('FhRetailCustomers', FhRetailCustomers);
    Vue.component('FhReturnOrder', FhReturnOrder);
    Vue.component('FhSettingsCenter', FhSettingsCenter);
    Vue.component('FhSubscribed', FhSubscribed);
    Vue.component('FhTransactionRecord', FhTransactionRecord);
    Vue.component('FhWonDeal', FhWonDeal);
    Vue.component('FhWorkbench', FhWorkbench);
    Vue.component('QfTable', QfTable);
    Vue.component('lySkeletonRecord', lySkeletonRecord);
    Vue.component('lySkeletonOperation', lySkeletonOperation);
    Vue.component('FhSelect', FhSelect);

    Vue.component('Baojiadan', Baojiadan);
    Vue.component('BianjixiansuoiDibu', BianjixiansuoiDibu);
    Vue.component('Bianjiye', Bianjiye);
    Vue.component('BookOpen', BookOpen);
    Vue.component('Bumen', Bumen);
    Vue.component('Chanpin', Chanpin);
    Vue.component('Chaolianjie', Chaolianjie);
    Vue.component('Clue', Clue);
    Vue.component('Dailishang', Dailishang);
    Vue.component('Dancidaoru', Dancidaoru);
    Vue.component('Danhangwenben', Danhangwenben);
    Vue.component('Danxuan', Danxuan);
    Vue.component('Daorujilu', Daorujilu);
    Vue.component('Dianzan', Dianzan);
    Vue.component('DibubiaoqianlaniconGongzuorichengMoren', DibubiaoqianlaniconGongzuorichengMoren);
    Vue.component('DibubiaoqianlaniconKehuMoren', DibubiaoqianlaniconKehuMoren);
    Vue.component('DibubiaoqianlaniconLianxirenMoren', DibubiaoqianlaniconLianxirenMoren);
    Vue.component('DibubiaoqianlaniconShangjiMoren', DibubiaoqianlaniconShangjiMoren);
    Vue.component('DibubiaoqianlaniconShouyeMoren', DibubiaoqianlaniconShouyeMoren);
    Vue.component('Dingdan', Dingdan);
    Vue.component('Dingdan0', Dingdan0);
    Vue.component('Dingshirenwu', Dingshirenwu);
    Vue.component('Duohangwenben', Duohangwenben);
    Vue.component('Duoxuan', Duoxuan);
    Vue.component('Fujian', Fujian);
    Vue.component('GengduoDibu', GengduoDibu);
    Vue.component('Headset', Headset);
    Vue.component('Hetong', Hetong);
    Vue.component('HuoshanyuyinfeiyongB27632pf', HuoshanyuyinfeiyongB27632pf);
    Vue.component('Jiebang', Jiebang);
    Vue.component('Jilianxuanze', Jilianxuanze);
    Vue.component('Jine', Jine);
    Vue.component('Jisuanleixing', Jisuanleixing);
    Vue.component('Kehu', Kehu);
    Vue.component('Liebiaoye', Liebiaoye);
    Vue.component('LiuchengguanliB9jnokl3', LiuchengguanliB9jnokl3);
    Vue.component('Maikefeng', Maikefeng);
    Vue.component('PeopleSafe', PeopleSafe);
    Vue.component('Pinglun', Pinglun);
    Vue.component('Renwu', Renwu);
    Vue.component('Renyuan', Renyuan);
    Vue.component('Riqi', Riqi);
    Vue.component('Setting', Setting);
    Vue.component('Shaixuan', Shaixuan);
    Vue.component('Shanchu', Shanchu);
    Vue.component('Shangji', Shangji);
    Vue.component('Shenpi', Shenpi);
    Vue.component('Shouhoufuwu', Shouhoufuwu);
    Vue.component('Shuzi', Shuzi);
    Vue.component('Sousuo', Sousuo);
    Vue.component('Tianjiaqun', Tianjiaqun);
    Vue.component('TianjiaqunQunliao', TianjiaqunQunliao);
    Vue.component('Tianjiaxiezuoren', Tianjiaxiezuoren);
    Vue.component('Tixiaogongju', Tixiaogongju);
    Vue.component('Tixing', Tixing);
    Vue.component('VideoOne', VideoOne);
    Vue.component('VideoTwo', VideoTwo);
    Vue.component('Weikaishi', Weikaishi);
    Vue.component('Xialadanxuan', Xialadanxuan);
    Vue.component('Xialaduoxuan', Xialaduoxuan);
    Vue.component('Xiangqingye', Xiangqingye);
    Vue.component('XinjianrichengDibu', XinjianrichengDibu);
    Vue.component('Xinjianye', Xinjianye);
    Vue.component('Yinyongziduan', Yinyongziduan);
    Vue.component('Zan', Zan);
    Vue.component('Zhanghao', Zhanghao);
    Vue.component('ZhanghaoquanxianBikgkki7', ZhanghaoquanxianBikgkki7);
    Vue.component('Zhaozhaoguanlian', Zhaozhaoguanlian);
    Vue.component('ZhuanhuaDibu', ZhuanhuaDibu);
    Vue.component('Zidonghuaguanli', Zidonghuaguanli);
    Vue.component('Zujian1', Zujian1);
    Vue.component('Zuopin', Zuopin);
    Vue.component('Zuzhiquanxian', Zuzhiquanxian);

    Vue.component('XlIconPlatformBaidu', IconPlatformBaidu);
    Vue.component('QfIconClue', IconClue);
    Vue.component('QfIconFeiShuMinutes', IconFeiShuMinutes);
    Vue.component('QfIconSetting', IconSetting);
    Vue.component('QfIconClient', IconClient);
    Vue.component('QfIconDialPhone', IconDialPhone);
    Vue.component('QfIconOpportunity', IconOpportunity);
    Vue.component('QfIconBusiness', IconBusiness);
    Vue.component('QfIconTransferClient', IconTransferClient);
    Vue.component('QfIconTransferOpportunity', IconTransferOpportunity);
    Vue.component('QfIconProductMenu', IconProductMenu);
    Vue.component('QfIconVolcanoVoice', IconVolcanoVoice);
    Vue.component('QfIconApprove', IconApprove);

    Vue.component('QfIconLayoutAdd', IconLayoutAdd);
    Vue.component('QfIconLayoutDetail', IconLayoutDetail);
    Vue.component('QfIconLayoutEdit', IconLayoutEdit);
    Vue.component('QfIconLayoutList', IconLayoutList);
    Vue.component('QfIconLayoutDel', IconLayoutDel);
    Vue.component('QfIconSortUp', IconSortUp);
    Vue.component('QfIconSortDown', IconSortDown);

    Vue.component('QfIconCooperation', IconCooperation);
    Vue.component('QfIconChat', IconChat);
    Vue.component('QfIconCount', IconCount);
    Vue.component('QfIconQuote', IconQuote);
    Vue.component('QfIconMoney', IconMoney);
    Vue.component('QfIconExcel', IconExcel);
    Vue.component('QfIconPpt', IconPpt);
    Vue.component('QfIconWord', IconWord);
    Vue.component('QfIconPdf', IconPdf);
    Vue.component('QfIconZip', IconZip);
    Vue.component('QfIconFile', IconFile);

    Vue.component('QfIconOther', IconOther);
    Vue.component('QfIconImg', IconImg);
    Vue.component('QfIconVideo', IconVideo);
    Vue.component('QfIconCode', IconCode);
    Vue.component('QfIconSubForm', IconSubForm);
    Vue.component('QfIconRequired', IconRequired);
    Vue.component('QfIconLog', IconLog);
    Vue.component('QfIconDing', IconDing);
    Vue.component('QfIconLeadsPool', IconLeadsPool);

    Vue.component('QfIconService', IconService);
    Vue.component('QfIconGroup', IconGroup);
    Vue.component('QfIconPriceSheet', IconPriceSheet);
    Vue.component('QfIconContract', IconContract);
    Vue.component('QfIconOrder', IconOrder);
    Vue.component('XlTree', XlTree);
    Vue.component('XlReturn', XlReturn);
    Vue.component('QfIconResult', IconResult);
    Vue.component('QfIconDoing', IconDoing);

    Vue.component('QfIconComment', IconComment);
    Vue.component('QfIconCommentActive', IconCommentActive);
    Vue.component('QfIconUpvote', IconUpvote);
    Vue.component('QfIconUpvoteActive', IconUpvoteActive);
    Vue.component('QfIconChaolianjie', IconChaolianjie);
    Vue.component('QfIconChazhaoguanlian', IconChazhaoguanlian);
    Vue.component('QfIconDanhang', IconDanhang);
    Vue.component('QfIconDanxuan', IconDanxuan);
    Vue.component('QfIconDuoxuan', IconDuoxuan);
    Vue.component('QfIconDuohangwenben', IconDuohangwenben);
    Vue.component('QfIconFujian', IconFujian);
    Vue.component('QfIconAutoFlow', IconAutoFlow);
    Vue.component('QfIconSendMsg', IconSendMsg);
    Vue.component('QfIconJilianxuanze', IconJilianxuanze);
    Vue.component('QfIconRenyuan', IconRenyuan);
    Vue.component('QfIconRiqi', IconRiqi);
    Vue.component('QfIconShuzi', IconShuzi);
    Vue.component('QfIconTixing', IconTixing);
    Vue.component('QfIconXialadanxuan', IconXialadanxuan);
    Vue.component('QfIconXialaduoxuan', IconXialaduoxuan);
    Vue.component('QfIconZujian', IconZujian);
    Vue.component('QfIconDepart', IconDepart);
    Vue.component('QfIconPercent', IconPercent);
    Vue.component('QfIconBaifenbi', IconBaifenbi);
    Vue.component('QfIconBianma', IconBianma);
    Vue.component('QfIconTable', IconTable);
    Vue.component('QfIconMoney', IconMoney);
    Vue.component('QfIconMetCondition', IconMetCondition);
    Vue.component('QfIconTimeTrigger', IconTimeTrigger);
    Vue.component('QfIconAddRecord', IconAddRecord);
    Vue.component('QfIconListGroup', IconListGroup);
    Vue.component('QfIconColumnSetting', IconColumnSetting);
    Vue.component('QfIconTableFiltrate', IconTableFiltrate);
    Vue.component('QfIconTableSort', IconTableSort);
    Vue.component('QfIconTaskCenter', IconTaskCenter);

    Vue.component('QfIconHandleSource', IconCaoZuoLaiYuan);
    Vue.component('QfIconHandleType', IconCaoZuoLeiXing);
    Vue.component('QfIconHandleFields', IconCaoZuoZiDuan);

    Vue.component('QfIconWarn', IconWarn);
    Vue.component('QfIconFieldOrder', IconFieldOrder);

    Vue.component('QfIconMenuInterface', IconMenuInterface);
    Vue.component('QfIconSwitchIdentity', IconSwitchIdentity);
    Vue.component('QfIconTenement', IconTenement);
    Vue.component('QfIconMultiMobile', IconMultiMobile);
    Vue.component('QfIconFuwenben', IconFuwenben);
    Vue.component('QfIconTabOne', IconTabOne);
    Vue.component('QfIconTabTwo', IconTabTwo);
    Vue.component('XlChart', XlChart);
    Vue.component('XlTable', XlTable);
    Vue.component('XlDatePicker', XlDatePicker);
    Vue.component('XlSearch', XlSearch);
    Vue.component('XlMember', XlMember);
    Vue.component('FhLoading', FhLoading);

    Vue.component('xlStatus', xlStatus);
    Vue.component('XlPrice', XlPrice);
    Vue.component('XlTab', XlTab);
    Vue.component('XlTabs', XlTabs);
    Vue.component('XlTreeMemberModal', XlTreeMemberModal);
    Vue.component('xlUserDepart', xlUserDepart);
    // Vue.component('XlTreeMemberSelect', XlTreeMemberSelect);
    Vue.component('XlColSelect', XlColSelect);
    Vue.component('XlAvatar', XlAvatar);
    Vue.component('XlEmpty', XlEmpty);
    Vue.component('XlEditDiv', XlEditDiv);
    Vue.component('FhAttachmentUpload', FhAttachmentUpload);
    Vue.component('FhPreviewModal', FhPreviewModal); //预览弹窗
    Vue.component('FhAttachmentPreview', FhAttachmentPreview);
    Vue.component('FhImgWatermark', FhImgWatermark);
    Vue.component('FhUploadModal', FhUploadModal); //附件上传弹窗

    Vue.component('XlUpload', XlUpload);

    Vue.component('XlFlowStage', XlFlowStage);
    Vue.component('XlLabelText', XlLabelText);
    Vue.component('XlOrder', XlOrder);
    Vue.component('XlBreadcrumb', XlBreadcrumb);
    Vue.component('XlNoPermission', XlNoPermission);
    Vue.component('XlSelectTree', XlSelectTree);
    Vue.component('XlGlobalTree', XlGlobalTree);
    Vue.component('XlDot', XlDot);
    Vue.component('QfDotAnimation', QfDotAnimation);
    Vue.component('XlHeader', XlHeader);
    Vue.component('XlSchedule', XlSchedule);
    Vue.component('XlContacts', XlContacts);
    Vue.component('XlCalllog', XlCalllog);
    Vue.component('XlOutCallMky', XlOutCallMky);
    Vue.component('XlOutCallTky', XlOutCallTky);
    Vue.component('XlOutCallCxkj', XlOutCallCxkj);
    Vue.component('XlOperationLog', XlOperationLog);

    Vue.component('XlClueTransform', XlClueTransform);
    Vue.component('XlCooperation', XlCooperation);
    Vue.component('QfConditionUltra', QfConditionUltra);

    Vue.component('XlRecord', XlRecord);
    Vue.component('XlFindObj', XlFindObj);
    Vue.component('XlFollowField', XlFollowField);
    Vue.component('XlAssociation', XlAssociation);
    Vue.component('XlEntityDataList', XlEntityDataList);
    Vue.component('XlSelectContacts', XlSelectContacts);
    Vue.component('XlUpdateRecords', XlUpdateRecords);
    Vue.component('XlUpdateSchedule', XlUpdateSchedule);
    Vue.component('XlTransfer', XlTransfer);
    Vue.component('XlBusinessInformation', XlBusinessInformation);
    Vue.component('XlBusinessMessage', XlBusinessMessage);
    Vue.component('XlCloudDocument', XlCloudDocument);
    Vue.component('XlExport', XlExport);
    Vue.component('XlImportEdit', XlImportEdit);
    Vue.component('XlContract', XlContract);
    Vue.component('BulkEditing', BulkEditing);
    /*** 报价单 S***/
    Vue.component('XlPriceSheet', XlPriceSheet);
    /*** 报价单 E***/
    // Vue.component('XlOpportunityTab', XlOpportunityTab);
    Vue.component('XlBandCustomer', XlBandCustomer);
    Vue.component('XlRepeatButton', XlRepeatButton);
    Vue.component('BingDataSync', BingDataSync);
    Vue.component('XlFieldCascade', XlFieldCascade);
    Vue.component('XlUpdateFields', XlUpdateFields);
    Vue.component('FhUpdateFields', FhUpdateFields);
    Vue.component('FhHeader', FhHeader);
    Vue.component('FhAbstract', FhAbstract);
    Vue.component('LyAddEdit', LyAddEdit);
    Vue.component('FhAddEdit', FhAddEdit);
    Vue.component('FhTabPage', FhTabPage);
    Vue.component('FhFields', FhFields);
    // Vue.component('LyTable', LyTable);
    Vue.component('LyAttachmentList', LyAttachmentList);
    Vue.component('LyAssociation', LyAssociation);
    Vue.component('lyForm', lyForm);
    Vue.component('LyList', LyList);

    Vue.component('LyShowFilters', LyShowFilters);

    Vue.component('FhTable', FhTable);

    Vue.component('lyListGroupLayout', lyListGroupLayout);
    Vue.component('LyListLayout', LyListLayout);
    Vue.component('lyListShortcutButtons', lyListShortcutButtons);
    Vue.component('lyListBatchButtons', lyListBatchButtons);
    Vue.component('FhColSelect', FhColSelect);
    Vue.component('TableInnerEdit', TableInnerEdit);
    Vue.component('TableInnerEditContent', TableInnerEditContent);
    Vue.component('FhPerson', FhPerson);
    //
    Vue.component('lyQuickEdit', lyQuickEdit);
    Vue.component('LySkeleton', LySkeleton);
    Vue.component('LyAdvancedFilter', LyAdvancedFilter);
    Vue.component('DropdownFilter', DropdownFilter);
    Vue.component('FieldFilter', FieldFilter);
    Vue.component('CommonSearch', CommonSearch);
    Vue.component('LyRecipient', LyRecipient);
    Vue.component('XlMemberTips;', XlMemberTips);
    Vue.component('LyFieldMapping', LyFieldMapping);
    Vue.component('LyFieldFilter', LyFieldFilter);
    Vue.component('lyComputedTip', lyComputedTip);
    Vue.component('lyComputedIconTips', lyComputedIconTips);

    Vue.component('lyFormTable', lyFormTable);
    Vue.component('lySubformTable', lySubformTable); //子表单
    Vue.component('XlGuide', XlGuide);
    Vue.component('LyAvatar', LyAvatar);
    Vue.component('LyDetail', LyDetail);
    Vue.component('FhButtons', FhButtons);
    Vue.component('XlDistribution', XlDistribution);
    Vue.component('XlPoolTransfer', XlPoolTransfer);
    Vue.component('XlSelectIcon', XlSelectIcon);
    Vue.component('XlColorPicker', XlColorPicker);
    Vue.component('LyColMore', LyColMore);
    Vue.component('LyTransfer', LyTransfer);
    Vue.component('LyTagFields', LyTagFields);
    Vue.component('XlTablePopover', XlTablePopover);
    Vue.component('XlParamCondition', XlParamCondition);
    Vue.component('XlSourceCondition', XlSourceCondition);
    Vue.component('FindFieldCondition', FindFieldCondition);
    // Vue.component('XlTreeOrganization', XlTreeOrganization);
    Vue.component('SysObj', SysObj);
    Vue.component('XlTreeOrg', XlTreeOrg);
    Vue.component('ChangePassword', ChangePassword);
    Vue.component('XlCheckName', XlCheckName);
    Vue.component('customFieldCondition', customFieldCondition);
    Vue.component('FhCustomSearchUltra', CustomSearchUltra);
    Vue.component('XlDateVariable', XlDateVariable);
    Vue.component('WEditor', WEditor);
    Vue.component('OrgPersionList', OrgPersionList);
    Vue.component('lyRichText', lyRichText);
    Vue.component('lyEditorDialog', lyEditorDialog);
  }
};
